import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

const Wrapper = css`
  background-color: ${theme.colors.darkBlues[5]};
  display: flex;
  flex-column: column;
  justify-content: center;
  min-height: calc(100vh - 160px - 63px);

  h1 {
    color: ${theme.colors.darkBlues[100]};
    font-weight: ${theme.fontWeights.regular};
  }

  p {
    color: ${theme.colors.darkBlues[90]};
    font-size: ${theme.fontSizes[2]};
    line-height: ${theme.lineHeights[3]};
  }

  img {
    margin: ${theme.space[2]};
  }

  button {
    margin: ${theme.space[3]};
  }

  .errorPanel {
    align-items: center;
    display: flex;
    justify-content: center;
    max-width: ${theme.breakpoints[0]};
    width: 100%;

    .errorText {
      text-align: center;
    }
  }
`;

export { Wrapper };
